import { render, staticRenderFns } from "./healthexamination.vue?vue&type=template&id=d94b9d6e&"
import script from "./healthexamination.vue?vue&type=script&lang=js&"
export * from "./healthexamination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports